import Request from '@request/Request';
import Model from '@models/User';

export default class extends Request {
  constructor(validationObserver, data = {}) {
    if (data.hasOwnProperty('business') && !data.business) {
      data.business = Model.data().business;
    }
    data = {
      ...Model.data(),
      ...data,
    };
    if (data.role !== 'tourism-operator') {
      delete data.business;
    }
    if (data.role && data.role === 'community-manager') {
      data.bank_name = data.bank_name || '';
      data.bank_account_number = data.bank_account_number || '';
      delete data.email;
    } else if (data.role && data.role === 'tourist') {
      data.years_of_diving = data.years_of_diving || '';
      data.no_of_dives = data.no_of_dives || '';
      data.country_code = data.country_code || '';
    }
    super(validationObserver, data);
    this.model = new Model();
    this.$validator = validationObserver;
  }

  async submit() {
    this.beforeSubmit();
    try {
      let response = await this.model.save(this.data());
      $showSuccess(response.message, 'user-toast');
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }

  async linkOperatorAndCommunityManagers(data) {
    this.beforeSubmit();
    try {
      let response = await this.model.linkOperatorAndCommunityManagers(data);
      $showSuccess(response.message, 'user-toast');
      return response;
    } catch (error) {
      this.handleError(error);
    } finally {
      this.afterSubmit();
    }
  }
}
